import { REGULATIONS } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';
import validate, { displayErrorText } from 'containers/services/validateForm';
import { get, isEmpty } from 'lodash';
import {
  NONE,
  RECIPIENT,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';
import { RISK_NAME } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { arrayTranslate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
export const riskInformationConstraints = (risk: any) => {
  return {
    [REGULATIONS.PROCESS_NATURE]: {
      presence: risk.riskName !== RISK_NAME.GARANTIES_ANNEXES,
    },
    [REGULATIONS.BENEFICIARY_RECIPIENT]: {
      presence: true,
    },
    [REGULATIONS.REGULATION_NATURE]: {
      presence: risk.riskName === RISK_NAME.CORPOREAL,
    },
    [REGULATIONS.COURT_NUMBER]: {
      presence: risk.riskName !== RISK_NAME.GARANTIES_ANNEXES,
    },
    [REGULATIONS.TOWN_CODE]: {
      presence:
        get(risk, 'regulationInfo.beneficiaryRecipient', '') === RECIPIENT.CDRA
          ? false
          : true,
    },
    [REGULATIONS.OPPOSING_LAWYER]: {
      presence:
        risk.riskName === RISK_NAME.CORPOREAL &&
        get(risk, 'regulationInfo.beneficiaryRecipient', '').includes(
          RECIPIENT.CDRA,
        )
          ? true
          : false,
    },
    [REGULATIONS.OPPOSING_LAWYER_EMAIL]: {
      presence: false,
      format: {
        pattern: /^$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: messages.opposingLawyerEmailError,
      },
    },
    [REGULATIONS.REGULATION_DATE]: {
      presence: risk.riskName === RISK_NAME.CORPOREAL,
      format: {
        pattern: /^(\d{4})-(\d{2})-(\d{2})$/,
        message: messages.settlementDateError,
      },
    },
    [REGULATIONS.JUDGEMENT_DATE]: {
      presence: risk.riskName !== RISK_NAME.GARANTIES_ANNEXES,
    },
    [REGULATIONS.JUDGEMENT_DATE_JAF]: {
      presence:
        (get(risk.regulationInfo, REGULATIONS.IS_APPEAL, false) ||
          get(risk.regulationInfo, REGULATIONS.JUDGEMENT_DATE) === NONE) &&
        risk.riskName === RISK_NAME.CORPOREAL,
    },
    [REGULATIONS.REAL_BENEFICIARY]: {
      presence: true,
    },
    [REGULATIONS.BNEJ_TAX_AMOUNT]: {
      presence:
        risk.riskName === RISK_NAME.CORPOREAL &&
        get(risk, 'regulationInfo.beneficiaryRecipient') === RECIPIENT.BNEJ
          ? true
          : false,
    },
    [REGULATIONS.CITY_CODE]: {
      presence:
        risk.riskName === RISK_NAME.CORPOREAL &&
        (get(risk, 'regulationInfo.beneficiaryRecipient') === RECIPIENT.BNEJ
          ? true
          : false),
    },
    [REGULATIONS.BENEFICIARY_REFERENCE]: {
      presence: risk.riskName === RISK_NAME.CORPOREAL ? true : false,
    },
    [REGULATIONS.BNEJ_NUMBER]: {
      presence:
        risk.riskName === RISK_NAME.CORPOREAL &&
        (get(risk, 'regulationInfo.beneficiaryRecipient') === RECIPIENT.BNEJ
          ? true
          : false),
    },
  };
};
export const riskInfoValidator = (risk: any) => {
  return validate(
    get(risk, 'regulationInfo', {}),
    riskInformationConstraints(risk),
  );
};
export const validateRisk = (risk: any, formatMessage: any) => {
  const validateRiskInformation = riskInfoValidator(risk);

  const translateArrayErrorMessages = arrayTranslate(formatMessage);
  const { message } =
    displayErrorText(
      validateRiskInformation,
      translateArrayErrorMessages(validateRiskInformation, true),
    ) || {};

  return !isEmpty(risk) ? message : '';
};
